import arrayMap from './_arrayMap.js';

/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */
function baseToPairs(object, props) {
  return arrayMap(props, function(key) {
    return [key, object[key]];
  });
}

export default baseToPairs;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_baseToPairs.js
// module id = 1133
// module chunks = 0